import {
	ArrowheadDownIcon,
	LogoutOutlineIcon,
	useClickAway,
} from "@rageeb/frontend-lib";
import { type FC, useState } from "react";
import { useAuth } from "../../hooks/use-auth";

const AccountPreview: FC = () => {
	const [isOpen, setIsOpen] = useState(false);

	const { user, logout } = useAuth();

	const onLogout = async () => {
		await logout();
	};

	const userName = user?.name;

	const ref = useClickAway<HTMLDivElement>(() => {
		setIsOpen(false);
	});

	const handleOpen = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className="relative" ref={ref}>
			<div
				className="flex h-12 cursor-pointer select-none items-center justify-center gap-2 rounded-md bg-white py-4 pr-4 pl-3 shadow-[0px_2px_12px_0px_rgba(0,23,46,0.08)]"
				onClick={handleOpen}
				id="account-preview--dropdown"
			>
				<span className="text-center font-bold text-[#222230] text-base capitalize leading-4">
					{userName}
				</span>
				<ArrowheadDownIcon />
			</div>
			{isOpen && (
				<div
					className="absolute top-[55px] right-0 z-[1] flex w-[244px] shrink-0 flex-col items-start gap-4 rounded-xl bg-white p-4 shadow-[0px_12px_30px_0px_rgba(0,23,46,0.15)]"
					onClick={() => setIsOpen(false)}
				>
					<div
						className="flex w-full cursor-pointer items-center justify-start gap-3 font-semibold text-[#222230] text-sm leading-[22px] no-underline"
						onClick={onLogout}
					>
						<LogoutOutlineIcon />
						Log out
					</div>
				</div>
			)}
		</div>
	);
};

export { AccountPreview };
